import Glide from "@glidejs/glide";
import $ from "jquery";

// $(document).ready(() => {
//     if($('.glide').length > 0) {
//         new Glide('.glide', {
//             type: 'carousel',
//             startAt: 0,
//             focusAt: 'center',
//         }).mount();
//     }
// });

$(() => {
  const carousels = $(".intro-carousel");
  if (carousels.length) {
    carousels.each((i, carouselEl) => {
      const carousel = $(carouselEl);
      const getPerView = () => {
        const windowWidth = $(window).outerWidth();
        if (windowWidth < 768) {
          return 2;
        }
        if (windowWidth >= 768) {
          return 4;
        }
      };
      const getPeek = () => {
        const windowWidth = $(window).outerWidth();
        if (windowWidth < 768) {
          return 0;
        }
        if (windowWidth >= 768) {
          return Math.min(windowWidth / 5, 370);
        }
      };
      const glide = new Glide(carousel.find(".glide")[0], {
        rewind: true,
        perView: 1,
        gap: 16,
        bound: true,
        focusAt: 0,
        peek: getPeek(),
      });
      glide.mount();
      glide.on("resize", () => {
        // console.log(getGap(), getPerView());
        glide.update({ peek: getPeek() });
      });
      glide.on("move.after", () => {
        const index = glide.index + 1;
        carousel.find(".carousel-index").text(index);
      });
    });
  }
});
